import React from "react";

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <g>
      <path className="euiIcon__fillSecondary" d="M8.33,23.67 L13.12,13.12 L23.67,8.33 L18.88,18.88 L8.33,23.67 Z M14.63,14.67 L12.35,19.67 L17.35,17.39 L19.63,12.39 L14.63,14.67 Z"/>
      <path
        d="M16,0 C7.163444,-5.41083001e-16 1.082166e-15,7.163444 0,16 C-1.082166e-15,24.836556 7.163444,32 16,32 C24.836556,32 32,24.836556 32,16 C32,11.7565362 30.3142906,7.68687356 27.3137085,4.6862915 C24.3131264,1.68570945 20.2434638,2.5983722e-16 16,0 Z M17,29.95 L17,28 L15,28 L15,29.95 C8.06698785,29.4468876 2.55311236,23.9330122 2.05,17 L4,17 L4,15 L2.05,15 C2.55311236,8.06698785 8.06698785,2.55311236 15,2.05 L15,4 L17,4 L17,2.05 C23.9330122,2.55311236 29.4468876,8.06698785 29.95,15 L28,15 L28,17 L29.95,17 C29.4468876,23.9330122 23.9330122,29.4468876 17,29.95 Z"/>
    </g>
  </svg>
)
